export default __webpack_public_path__ + "static/media/2nd.2.09d930cf.jpg";